import { render, staticRenderFns } from "./CommentFilesDescription.vue?vue&type=template&id=29fd216c&scoped=true"
import script from "./CommentFilesDescription.vue?vue&type=script&lang=js"
export * from "./CommentFilesDescription.vue?vue&type=script&lang=js"
import style0 from "./CommentFilesDescription.vue?vue&type=style&index=0&id=29fd216c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fd216c",
  null
  
)

export default component.exports